/**
 * Calculates start (sdate) and end (edate) date strings in 'YYYY-MM-DD' format
 * corresponding to aging duration bucket.
 * 
 * Bucket definitions based on DATEDIFF(CURDATE(), request_date):
 * - "0-10": 0 to 10 days ago (sdate: today - 10 days, edate: today)
 * - "11-15": 11 to 15 days ago (sdate: today - 15 days, edate: today - 11 days)
 * - "16-30": 16 to 30 days ago (sdate: today - 30 days, edate: today - 16 days)
 * - "31-90": 31 to 90 days ago (sdate: today - 90 days, edate: today - 31 days)
 * - "91-180": 91 to 180 days ago (sdate: today - 180 days, edate: today - 91 days)
 * - "181-365": 181 to 365 days ago (sdate: today - 365 days, edate: today - 181 days)
 * - "365+": More than 365 days ago (sdate: today - 5 years, edate: today - 366 days)
 */
export function getDateRangeForDays(daysRange) {
  if (!daysRange) return null;

  const formatDate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (daysRange === '0-10') {
    const start = new Date(today);
    start.setDate(today.getDate() - 10);
    return { sdate: formatDate(start), edate: formatDate(today) };
  } else if (daysRange === '11-15') {
    const start = new Date(today);
    start.setDate(today.getDate() - 15);
    const end = new Date(today);
    end.setDate(today.getDate() - 11);
    return { sdate: formatDate(start), edate: formatDate(end) };
  } else if (daysRange === '16-30') {
    const start = new Date(today);
    start.setDate(today.getDate() - 30);
    const end = new Date(today);
    end.setDate(today.getDate() - 16);
    return { sdate: formatDate(start), edate: formatDate(end) };
  } else if (daysRange === '31-90') {
    const start = new Date(today);
    start.setDate(today.getDate() - 90);
    const end = new Date(today);
    end.setDate(today.getDate() - 31);
    return { sdate: formatDate(start), edate: formatDate(end) };
  } else if (daysRange === '91-180') {
    const start = new Date(today);
    start.setDate(today.getDate() - 180);
    const end = new Date(today);
    end.setDate(today.getDate() - 91);
    return { sdate: formatDate(start), edate: formatDate(end) };
  } else if (daysRange === '181-365') {
    const start = new Date(today);
    start.setDate(today.getDate() - 365);
    const end = new Date(today);
    end.setDate(today.getDate() - 181);
    return { sdate: formatDate(start), edate: formatDate(end) };
  } else if (daysRange === '365+') {
    const start = new Date(today);
    start.setFullYear(today.getFullYear() - 5);
    const end = new Date(today);
    end.setDate(today.getDate() - 366);
    return { sdate: formatDate(start), edate: formatDate(end) };
  } else if (daysRange === 'all' || daysRange === 'total') {
    const start = new Date(today);
    start.setFullYear(today.getFullYear() - 5);
    return { sdate: formatDate(start), edate: formatDate(today) };
  }

  return null;
}

